import { transparentize, getLuminance } from "polished";
import { inIframe } from "./embed";

export default ({ site, darkMode }) => {
  // this checks to see if theme is a light or dark theme... is set to true if is a light theme.
  const isLight = site.primaryColor
    ? getLuminance(site.primaryColor) > 0.7
    : false;

  let theme = {
    title: site.title,
    isEmbeded: inIframe(),
    light: !darkMode && isLight,
    primary: site.primaryColor || "#666",
    computedPrimary: isLight
      ? transparentize(0.6, site.primaryTextColor || "#333")
      : site.primaryColor || "#666",
    primaryText: site.primaryTextColor || "#333",
    appBarText: "black",
    background: site.backgroundColor || "#F8F8F8",
    selectedColor: isLight
      ? site.primaryTextColor || "#333"
      : site.primaryColor || "#F8F8F8",
    hightlightColor: isLight
      ? site.primaryTextColor || "#333"
      : site.primaryColor || "#F8F8F8",
    matchedColor: isLight
      ? transparentize(0.7, site.primaryTextColor || "#333")
      : site.primaryColor || "#F8F8F8",
    textOnPrimary: site.textOnPrimary || isLight ? "black" : "white",
    textSecondaryOnPrimary: transparentize(
      0.2,
      site.textOnPrimary || isLight ? "black" : "white"
    ),
    uiFont: `"${site.uiFont}", sans-serif` || "'Noto Sans', sans-serif",
    bibleFont: `"${site.bibleFont}", sans-serif` || "'Noto Sans', sans-serif",
    scriptDirection: site.scriptDirection.toLowerCase(),
    showBibleAbbreviations: site.showBibleAbbreviations,
    darkMode
  };

  const darkTheme = {
    light: false,
    computedPrimary: "#353535",
    primaryText: "white",
    background: "#202020",
    appBarText: "white",
    textOnPrimary: "white",
    hightlightColor: "#FFFFFF66",
    selectedColor: "#FFFFFF",
    matchedColor: "#FFFFFF"
  };

  if (darkMode) {
    theme = Object.assign({}, theme, darkTheme);
  }

  return theme;
};
